(function() {
  const body = document.body;
  let styleElement = null;
  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (body.classList.contains('Sea-Accessibility-stop_animations')) {
          disableMarquee();
        } else {
          enableMarquee();
        }
      }
    }
  });

  observer.observe(body, {attributes: true});
  if (body.classList.contains('Sea-Accessibility-stop_animations')) {
    disableMarquee();
  }
  function disableMarquee() {
    if (styleElement) {
      styleElement.remove();
    }
    styleElement = document.createElement('style');
    styleElement.id = 'sea-marquee-pause';
    styleElement.textContent = `
      body.Sea-Accessibility-stop_animations .marquee-group-track {
        animation: none !important;
        transform: translateX(0) !important;
      }
    `;
    document.head.appendChild(styleElement);
  }
  function enableMarquee() {
    if (styleElement) {
      styleElement.remove();
      styleElement = null;
    }
  }
})();